module.exports = __webpack_public_path__ + "img/product_icon.32e72d35.png";